import { FavouriteLayoutAttributes } from '../types';
import { configMappings } from './constants';
import { LayoutConfig } from '../favourite/common/layout-config';

const tileAttributesReader = (config: LayoutConfig) => (name: string) => {
  if (config.layoutAttributes.Tile && config.layoutAttributes.Tile.hasOwnProperty(name)) {
    return config.layoutAttributes.Tile[name];
  }
  return undefined;
};

const tableAttributesReader = (config: LayoutConfig) => (name: string) => {
  if (config.layoutAttributes.Table && config.layoutAttributes.Table.hasOwnProperty(name)) {
    return config.layoutAttributes.Table[name];
  }
  return undefined;
};

const configFactory = (attributesReader: typeof tileAttributesReader) => (layoutAttributes: FavouriteLayoutAttributes) => {

  const config = new LayoutConfig(layoutAttributes);
  const reader = attributesReader(config);

  return {
    suppressRepeatingRows: reader(configMappings.suppressRepeatingRows) === true,
    compactView: reader(configMappings.compactView) === true,
    hideAggrColumns: reader(configMappings.hideAggrColumns) === true,
    hideHeader: reader(configMappings.hideHeader) === true,
    hideTotals: reader(configMappings.hideTotals) === true,
    wideLayout: reader(configMappings.wideLayout) === true
  };
};

export const tileConfig = configFactory(tileAttributesReader);
export const tableConfig = configFactory(tableAttributesReader);
